import React, { Component, Suspense } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import { RecoilRoot } from 'recoil'
import ForgotPassword from './views/pages/Home/ForgotPassword'
import ValidatePassword from './views/pages/Home/ValidatePassword'
import ConfirmNewPassword from './views/pages/Home/confirmNewPassword'
import ChangePassword from './views/pages/changePassword/ChangePassword'

import RegistrationInstruction from './views/pages/Home/RegistrationInstruction'
import OnboardingRegistration from './views/pages/Home/OnboardingRegistration'
import RegistrationDetails from './views/pages/Home/RegistrationDetails'
import OtpScreen from './views/pages/Home/OtpScreen'
import RegistrationValidation from './views/pages/Home/RegistrationValidation'
import Tostify from './utils/Tostify'
import FirstTimeChangePassword from './views/pages/changePassword/FirstTimeChangePassword'
import ContactUs from './components/ContactUs'
import ScrollToTop from './utils/ScrollToTop'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Register = React.lazy(() => import('./views/pages/registration/registration'))
const Homepage = React.lazy(() => import('./views/pages/Home/Homepage'))
class App extends Component {
  render() {
    return (
      <>
        <Router>
          <ScrollToTop />
          <Suspense fallback={loading}>
            <RecoilRoot>
              <Routes>
                <Route exact path="/" element={<Homepage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/404" element={<Page404 />} />
                <Route path="/500" element={<Page500 />} />
                <Route path="/homepage" element={<Homepage />} />
                <Route
                  path="/change-password"
                  name="Change Password Page"
                  element={<ChangePassword />}
                />
                <Route
                  path="/forgot-password"
                  name="Forgot Password Page"
                  element={<ForgotPassword />}
                />
                <Route
                  path="/validate-password"
                  name="Validate Password Page"
                  element={<ValidatePassword />}
                />
                <Route
                  path="/confirm-new-password"
                  name="Confirm New Password Page"
                  element={<ConfirmNewPassword />}
                />
                <Route
                  path="/registration-instructions"
                  name="Registration Instruction"
                  element={<RegistrationInstruction />}
                />
                <Route
                  path="/onboarding-registration"
                  element={<OnboardingRegistration /> }/>
                <Route
                  path="/registration-details"
                  name="Registration Details"
                  element={<RegistrationDetails />}
                />
                <Route path="/otp-screen" name="OTP Screen" element={<OtpScreen />} />
                <Route
                  path="/registration-validation-details"
                  name="Registration Validation"
                  element={<RegistrationValidation />}
                />
                <Route path="/first-time-change-password" element={<FirstTimeChangePassword />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="*" element={<DefaultLayout />} />
              </Routes>
            </RecoilRoot>
          </Suspense>
        </Router>
        <Tostify />
      </>
    )
  }
}

export default App
